import React, { Component } from 'react'
import MicroFrontend from "../MicroFrontend";
import MicroFrontendContainer from './MicroFrontendContainer';

class MagnittHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            refresh: (props.userState && props.userState.is_loggedin ? 1 : 0),
        }
    }

    // refresh component when login status changes
    componentDidUpdate(prevProps) {
        const { userState } = this.props;
        try {
            if (userState && userState.is_loggedin !== prevProps.userState.is_loggedin) {
                const refresh = (userState.is_loggedin ? 1 : 0)
                this.setState({ refresh });
            }
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { refresh } = this.state;
        const { history, userState } = this.props;
        return (
            <MicroFrontendContainer
                MicroFrontend={MicroFrontend}
                refresh={refresh}
                history={history}
                data={{ userState }}
                name="MagnittHeader"
                height={this?.props?.userState?.is_loggedin ? "72.4px" : "179.3px"}
                skeletonId="magnittHeaderSkeleton"
                removeAbsolutePosition={true}
                className="magnitt-header-container"
            />
        )
    }
}

export default (MagnittHeader);
